<template>
  <div>
    <!-- 顶部导航 -->
    <TopNav></TopNav>
    <!-- 物联网平台轮播图 -->
    <ThingsBanner></ThingsBanner>
    <!-- 物联子系统 -->
    <IOT></IOT>
    <!-- 应用场景 -->
    <Application></Application>
    <!-- 底部导航 -->
    <ButtonNav></ButtonNav>
  </div>
</template>

<script>
import { reactive } from "vue";

import TopNav from "../../../../components/mobile/components/TopNav.vue";
import ButtonNav from "../../../../components/mobile/components/BottomNav.vue";
import ThingsBanner from "../../../../components/mobile/Product/ThingsComponents/ThingsBanner.vue";
import IOT from "../../../../components/mobile/Product/ThingsComponents/IOT.vue";
import Application from "../../../../components/mobile/Product/ThingsComponents/Application.vue";

export default {
  setup() {
    return reactive({});
  },
  components: {
    TopNav,
    ButtonNav,
    ThingsBanner,
    IOT,
    Application,
  },
};
</script>

<style scoped>
</style>
